module.exports = __webpack_public_path__ + "media/images/logo1-168817d15ae0e17a3f25e8b320ebb2ec.png";